export enum VerifyTransactionManualStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}
